import React from 'react';
import './CertificatePDF.css';

const CertificatePDF = React.forwardRef(({ participantName, dateIssued, certificateId }, ref) => {
    return (
        <div ref={ref} style={{ position: 'absolute', top: '-10000px', left: '-10000px' }}>
            <div className="certificate-container">
                <div className="certificate-border">
                    <div className="certificate-title">CERTIFICATE OF COMPLETION</div>

                    <div className="certificate-subtitle">This certifies that</div>

                    <div className="certificate-name">{participantName}</div>

                    <div className="certificate-text">
                        has successfully completed the requirements of the
                    </div>

                    <div className="certificate-course">
                        Dr. Dangleben EMS Online Course
                    </div>

                    <div className="certificate-text" style={{ maxWidth: '80%' }}>
                        including all educational modules and a final comprehensive examination<br />
                        with a score of 80% or higher.
                    </div>

                    <table className="certificate-table">
                        <tbody>
                            <tr>
                                <td>Certificate ID:</td>
                                <td>{certificateId}</td>
                            </tr>
                            <tr>
                                <td>Date Issued:</td>
                                <td>{dateIssued}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="certificate-footer">
                        <div className="certificate-signature-name">Dale A. Dangleben, MD, FACS</div>
                        <div className="certificate-signature-title">Founder – Caribbean EMS Initiative</div>
                        <div className="certificate-disclaimer">
                            This certificate represents successful completion of an educational program and is not a state EMT license.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default CertificatePDF;
